module.exports = __webpack_public_path__ + "img/CHEVRON_BOTTOM.1c3a8395.svg";